export const getData = () => ({
  projects: [
    {
      name: 'Banegas',
      coord: {
        lon: -83.54368268478389,
        lat: 8.686884232068753
      },
      projectID: '001',
      status: 'active',
      developer: 'Fundación Corcovado',
      country: 'Costa Rica',
      methodology: 'M000',
      programme: 'ERS 0.9',
      type: '0 - Reforestation',
      hectares: 4,
      shape: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/001/project-area-banegas.geojson',
      creditingStart: '2022-04-15',
      creditingEnd: '2055-04-15',
      zoom: 17,
      units: [
        {
          type: 'PRU',
          owner: 'Buffer Pool',
          total: 314,
          issuance: '2022',
          serial: 'ERS-0-001-CRI-PRU-2022-1-00000001-00000314'
        },
        {
          type: 'PRU',
          owner: 'Carbonable',
          total: 1573,
          issuance: '2022',
          serial: 'ERS-0-001-CRI-PRU-2022-2-00000315-00001887'
        },
      ],
      timeline: [
        {
          date:'2021-10',
          children: 'October 2021: baseline'
        },
        {
          date:'2021-10',
          children: 'October 2021: 1st reforestation'
        },
        {
          date:'2022-05',
          children: 'May 2022: Certification'
        },
        {
          date:'2022-08',
          children: 'August 2022: 2nd reforestation (2000 trees)'
        },
        {
          date:'2023-08',
          children: 'August 2023: 3rd reforestation (2000 trees)'
        }
      ],
      files: [
        {name: 'Project Design Document', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/001/PDD-banegas-farm.pdf'},
        {name: 'Reference area shapefile', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/001/reference-area-banegas.geojson'},
        {name: 'Project area shapefile', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/001/project-area-banegas.geojson'},
        {name: '2023 Annual Report', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/001/project-annual-report-2023-banegas.pdf'},
        {name: '2022 Annual Report', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/001/project-annual-report-2022-Banegas.pdf'}
      ]
    },
    {
      name: 'Las Delicias',
      projectID: '002',
      coord: {
        lon: -82.2414595979207,
        lat: 9.346052769575614
      },
      status: 'active',
      developer: 'Fundación Naturalez Panamá',
      country: 'Panama',
      methodology: 'M000',
      programme: 'ERS 0.9',
      type: '0 - Reforestation',
      hectares: 18,
      shape: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/002/project-area-las-delicias.geojson',
      creditingStart: '2022-04-15',
      creditingEnd: '2045-04-15',
      units: [
        {
          type: 'PRU',
          owner: 'Buffer Pool',
          total: 3783,
          issuance: '2022',
          serial: 'ERS-0-002-PA-PRU-2022-3-00001888-00005670'
        },
        {
          type: 'PRU',
          owner: 'Carbonable',
          total: 3603,
          issuance: '2022',
          serial: 'ERS-0-002-PA-PRU-2022-4-000005671-00009273'
        },/**
        {
          type: 'VRU',
          owner: 'Buffer Pool',
          total: 29,
          issuance: '2022',
          serial: 'ERS-0-002-PA-VRU-2022-7-00009281-00009309'
        },
        {
          type: 'VRU',
          owner: 'Carbonable',
          total: 26,
          issuance: '2022',
          serial: 'ERS-0-002-PA-VRU-2022-8-00009310-00009335'
        }*/
      ],
      timeline: [
        {
          date:'2022-05',
          children: 'May 2022: Certification'
        },
        {
          date:'2022-06',
          children: 'June 2022: soil preparation and propagule plantation'
        },
        {
          date:'2022-07',
          children: 'July 2022: Nursery construction'
        },
        {
          date:'2022-11',
          children: 'November 2022: propagule plantation'
        },
        {
          date:'2023-07',
          children: 'July 2023: Nursery construction'
        },
        {
          date:'2023-09',
          children: 'September 2023: bird infrastructure construction'
        }
      ],
      files: [
        {name: 'Project Design Document', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/002/PDD-las-delicias.pdf'},
        {name: 'Reference area shapefile', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/002/reference-area-las-delicias.geojson'},
        {name: 'Project area shapefile', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/002/project-area-las-delicias.geojson'},
        {name: '2023 Annual Report', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/002/project-annual-report-2023-las-delicias.pdf'},
        {name: '2022 Annual Report', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/002/project-annual-report-2022-las-delicias.pdf'}
      ]
    },
    {
      name: 'Manjarisoa',
      projectID: '003',
      coord: {
        lon: 49.1037,
        lat: -18.4560
      },
      status: 'active',
      developer: 'ForestCalling',
      country: 'Madagascar',
      methodology: 'M000',
      programme: 'ERS 0.9',
      type: '0 - Reforestation',
      hectares: 300,
      shape: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/003/project-area-manjarisoa.geojson',
      zoom: 13.5,
      creditingStart: '2022-09-01',
      creditingEnd: '2052-09-01',
      units: [
        {
          type: 'PRU',
          owner: 'Buffer Pool',
          total: 15729,
          issuance: '2022',
          serial: 'ERS-0-003-MDG-PRU-2022-5-00009277-00025005'
        },
        {
          type: 'PRU',
          owner: 'Carbonable',
          total: 8000,
          issuance: '2022',
          serial: 'ERS-0-003-MDG-PRU-2022-6-000025006-00033005'
        },
        {
          type: 'PRU',
          owner: 'ForestCalling',
          total: 54914,
          issuance: '2022',
          serial: 'ERS-0-003-MDG-PRU-2022-7-000033006-00087919'
        },
      ],
      timeline: [
        {
          date:'2022-04',
          children: 'April 2022: Baseline'
        },
        {
          date:'2022-09',
          children: 'September 2022: Certification'
        },
        {
          date:'2022-12',
          children: 'December 2022: Nursery construction'
        }
      ],
      files: [
        {name: 'Project Design Document', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/003/PDD-manjarisoa.pdf'},
        {name: 'Reference area shapefile', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/003/reference-area-manjarisoa.geojson'},
        {name: 'Project area shapefile', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/003/project-area-manjarisoa.geojson'},
        {name: '2022 Annual Report', url: 'https://ers-registry-docs.s3.eu-central-1.amazonaws.com/003/project-annual-report-2022-manjarisoa.pdf'}
      ]
    }
  ]
})